<svelte:options
  customElement={{
    tag: 'teo-loginscreen',
    extend: extendWithStyles,
  }}
/>

<script lang="ts">
  import type { TeoCore } from '@/teoCore/TeoCore';
  import LoginScreen from '@/ui/components/auth/Login/LoginScreen.svelte';
  import { TeoProvider } from '@/utils/teo-context';

  import { extendWithStyles } from './web-component-utils';

  let { teoCore }: { teoCore?: TeoCore } = $props();
</script>

<TeoProvider {teoCore}>
  <LoginScreen />
</TeoProvider>
